<template>
    <div class="error-container">
        <i class="fa fa-exclamation-circle error-icon"></i>
        <p>{{errorText}}</p>
    </div>
</template>

<script>
    export default {
        name: "ErrorInput",
        props: {
            text: String
        },
        data() {
            return {
                errorText: this.text
            }
        },
        watch: {
            text(newVal) {
                if (newVal) {
                    this.errorText = newVal;
                }
            }
        }
    }
</script>

<style scoped>
    .error-container {
        margin: auto;
        display: inline-block;
    }

    .error-icon, p {
        float: left !important;
        font-size: 15px !important;
        color: var(--primary-red) !important;
    }

    p {
        margin-left: 10px;
        width: fit-content;
    }
</style>